import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const GlobalMenuItem = ({ route, text, onNavigate = null }) => {
  const isPowerBiRoute = route === '/powerbi';
  const handleClick = event => {
    if (isPowerBiRoute || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (onNavigate) onNavigate(route);
  };

  return (
    <Link
      to={route}
      target={isPowerBiRoute ? '_blank' : undefined}
      rel={isPowerBiRoute ? 'opener' : undefined}
      className="link-button"
      onClick={handleClick}
    >
      <ListItem button className="menu-item">
        <ListItemText primary={text} className="menu-text" />
      </ListItem>
    </Link>
  );
};

GlobalMenuItem.propTypes = {
  onNavigate: PropTypes.func,
  route: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default GlobalMenuItem;
